import React from 'react';
import { Box, Typography } from '@mui/material';
import { type MessageSender } from '../model/chatTypes';

interface TypingIndicatorProps {
  sender: MessageSender;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ sender }) => {
  const label = sender === 'operator' ? 'Оператор печатает' : 'Бот печатает';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 2, py: 1 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: '3px',
          alignItems: 'center',
          '& span': {
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: 'text.disabled',
            display: 'inline-block',
            animation: 'chatTypingBounce 1.4s ease-in-out infinite both',
          },
          '& span:nth-of-type(1)': { animationDelay: '0s' },
          '& span:nth-of-type(2)': { animationDelay: '0.2s' },
          '& span:nth-of-type(3)': { animationDelay: '0.4s' },
          '@keyframes chatTypingBounce': {
            '0%, 80%, 100%': { transform: 'scale(0.6)', opacity: 0.4 },
            '40%': { transform: 'scale(1)', opacity: 1 },
          },
        }}
      >
        <span />
        <span />
        <span />
      </Box>
    </Box>
  );
};
